import React, {useCallback, useEffect} from 'react';
import * as S from './ErrorAlert.styles';
import Icon from '../IconsSelector';

type alertPopupProps = {
  title?: string;
  isHeaderIcon?: boolean;
  contentTxt?: string;
  footerBtn?: boolean;
  buttonName?: string;
  popupWidth?: string;
  onFooterBtnClick:any;
};

const AlertPopup = ({
  title,
  isHeaderIcon,
  contentTxt,
  footerBtn,
  buttonName,
  popupWidth,
  onFooterBtnClick
}: alertPopupProps) => {
  return (
    <S.AlertOverlay>
      <S.AlertPopup width={popupWidth}>
        <S.AlertHeader>
          <S.HeaderTxtWrap>
            {(isHeaderIcon && <Icon name="BellIcon" styleProps={{}} />) || ''}
            <S.HeaderTxt>{title}</S.HeaderTxt>
          </S.HeaderTxtWrap>
          <div>
            <Icon name="CloseIcon" styleProps={{}} />
          </div>
        </S.AlertHeader>
        <S.AlertContent>
          <S.ContentTxt>{contentTxt}</S.ContentTxt>
        </S.AlertContent>
        <S.AlertFooter>
          {(footerBtn && <S.FooterBtn onClick={onFooterBtnClick}>{buttonName}</S.FooterBtn>) || ''}
        </S.AlertFooter>
      </S.AlertPopup>
    </S.AlertOverlay>
  );
};

export default AlertPopup;
